// frontend/packages/business-console/src/contexts/MediaConfigContext.jsx
//
// Fetches public Cloudinary config (cloud name) once at workspace mount and
// exposes it to components that need to build image URLs client-side.
//
// The cloud name is safe to expose to signed-in users — it already appears
// in every asset URL returned from the Media Library. The only reason we
// fetch it rather than hard-code it in .env is to keep the console
// environment-agnostic (same build for UAT and PROD, backend decides).
//
// Usage:
//   const { cloudName } = useMediaConfig();
//   const url = buildCloudinaryUrl(token, cloudName, { width: 120 });

import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@upryzze/services";

const MediaConfigContext = createContext({ cloudName: "" });

export function MediaConfigProvider({ children }) {
  const [cloudName, setCloudName] = useState("");

  useEffect(() => {
    let alive = true;

    api
      .get("/v2/media/cloudinary/config")
      .then(({ data }) => {
        if (alive) setCloudName(String(data?.cloudName || ""));
      })
      .catch(() => {
        // Non-fatal — thumbnails will just render as empty placeholders.
        // A warning lives in the backend logs if cloud name isn't configured.
      });

    return () => {
      alive = false;
    };
  }, []);

  return (
    <MediaConfigContext.Provider value={{ cloudName }}>
      {children}
    </MediaConfigContext.Provider>
  );
}

export const useMediaConfig = () => useContext(MediaConfigContext);
